module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Sam_Picking_his_vitamins-Web-1280.97755a8a.jpg";